import { render, staticRenderFns } from "./SubmitReturnOrder.vue?vue&type=template&id=27f6f08a&scoped=true"
import script from "./SubmitReturnOrder.vue?vue&type=script&lang=ts"
export * from "./SubmitReturnOrder.vue?vue&type=script&lang=ts"
import style0 from "./SubmitReturnOrder.vue?vue&type=style&index=0&id=27f6f08a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f6f08a",
  null
  
)

export default component.exports